module.exports = __webpack_public_path__ + "static/media/icone_contactlettres.22d3e19b.svg";